import { render, staticRenderFns } from "./WordDocumentPreviewModal.vue?vue&type=template&id=9007702c&scoped=true&"
import script from "./WordDocumentPreviewModal.vue?vue&type=script&lang=js&"
export * from "./WordDocumentPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./WordDocumentPreviewModal.vue?vue&type=style&index=0&id=9007702c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9007702c",
  null
  
)

export default component.exports